import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { DpTableComponent } from '../../common-component/dp-table/dp-table.component';
import { NamesToUpdateService } from '../../services/raintree/Transmission/names-to-update.service';
import { AssignDataRes } from '../../services/raintree/interfaces/names-to-update.interface';
import { Validation } from '../../services/common/app.constant';

@Component({
  selector: 'edit-details-dialog',
  standalone: true,
  templateUrl: './edit-details-dialog.component.html',
  styleUrl: './edit-details-dialog.component.scss',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DpTableComponent,
    FormsModule,
    MatDialogModule,
  ],
})
export class EditDetailsDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<EditDetailsDialogComponent>,
    private _namesToUpdateService: NamesToUpdateService
  ) {}

  editDetailsForm = new FormGroup({
    serialNo: new FormControl(null),
    contactNo: new FormControl('',[Validators.pattern(Validation.regex.phone)]),
    address: new FormControl('',[Validators.pattern('^[^*]*$')]),
  });

  ngOnInit(): void {
    this.editDetailsForm.patchValue({
      serialNo: this.data.serialNo,
      contactNo: this.data.contact,
      address: this.data.addr,
    });
  }

  getFormValue(controlName: string): any {
    return this.editDetailsForm.get(controlName)?.value;
  }

  clearSerialNo() {
    this.editDetailsForm.get('serialNo')?.setValue(null);
  }

  editDetails() {
    let bodyObj = {
      dpwMemKey: this.getFormValue('serialNo'),
      contactNo: this.getFormValue('contactNo'),
      address: this.getFormValue('address'),
    };
    if(this.editDetailsForm.valid){
      this._namesToUpdateService.editDetails(this.data.id, bodyObj).subscribe({
        next: (res: AssignDataRes) => {
          this.dialogRef.close(bodyObj);
        },
        error: (error) => console.log(error),
      });
    } else {

        this.editDetailsForm.markAllAsTouched();


    }

  }
  closeFWDialog() {
    this.dialogRef.close();
  }
}
